module.exports = __webpack_public_path__ + "media/components/country-flag/static/vi-a99d0bea8777d75cf46074c3b866d348.svg";